import axios, {
  type AxiosRequestConfig,
  type AxiosResponse,
  type InternalAxiosRequestConfig,
} from 'axios';

// A client for calling Ecomm BFFs that includes the jwt token needed for authorization
const createClient = () =>
  axios.create({
    baseURL: 'https://api.example.com',
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const axiosClientInstance = createClient();

axiosClientInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    if (typeof window !== 'undefined') {
      const token = window.sessionStorage.getItem('access_token') || '';
      if (config?.headers && token) config.headers.Authorization = token;
    }
    return config;
  }
);

const axiosClientRequest = async <T>(
  config: AxiosRequestConfig
): Promise<AxiosResponse<T>> => {
  const response: AxiosResponse<T> = await axiosClientInstance({
    ...config,
  });

  return response;
};

export default axiosClientRequest;
